module.exports = __webpack_public_path__ + "static/media/031-The Drake - Canmore.ef9cb617.png";